import { CATEGORY_OPTIONS, SERVICE_CATEGORIES } from '../constants';

export default function getPoiCategoryLabel({ poiCategoryId, poiType }) {
  const categoryOptions = poiType === 1 ? CATEGORY_OPTIONS : SERVICE_CATEGORIES;
  const selectedCategory = categoryOptions.find(option => option.value === poiCategoryId);
  if (selectedCategory) return selectedCategory.label;
  throw new Error(`poi category ${poiCategoryId} for type ${poiType} not found in costants`);
}
